<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">盘点任务名称：</span>
        </div>
        <el-input v-model="formData.taskName" size="small" style="width: 280px" />
      </div>      
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">截至时间：</span>
        </div>
        <el-date-picker v-model="formData.deadlineDate" value-format="yyyy-MM-dd" placeholder="截至时间" size="small" style="width: 280px"></el-date-picker>
      </div>    
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" type="textarea" size="small" style="width: 280px" />
      </div>              
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>        
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Material";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "consuming-inventory-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "库存盘点"
        }
      ],
      mainTitle: "添加盘点",
      subheading: "",
      formData: {
        taskName: "",
        memo: "",
        deadlineDate: ""
      }
    };
  },
  methods: {
    confirm() {
      if (!this.formData.taskName) {
        nError("请输入盘点任务名称");
        return false;
      }
      this.$axios
        .post(api.addMaterialsStatisticTask, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "consuming-inventory"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "consuming-inventory"
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/ConsumingInventory/ConsumingInventoryAdd.vue